<!--
 * @Author: Ashley.Liu
 * @Date: 2022-08-02 15:55:52
 * @LastEditTime: 2022-09-01 15:01:34
 * @Description: desc
-->
<template>
  <zm-select
    ref="paginationSelect"
    v-model="curValue"
    size="small"
    clearable
    filterable
    remote
    :remote-method="remoteMethods"
    :loading="loading"
    :has-more="hasMore"
    v-bind="[$attrs]"
    v-on="$listeners"
  >
    <template #prefix v-if="showRefresh">
      <zm-button
        ghost
        icon="zm-icon-refresh"
        @click="$emit('refresh')"
        aria-label="Refresh"
      />
      <slot name="prefix"></slot>
    </template>
    <slot :options="pageableList"></slot>
  </zm-select>
</template>

<script>
import { getTwoDimeArray } from './utils'
export default {
  name: 'AsPaginationSelect',
  props: {
    value: {
      type: [String, Array],
    },
    optionsList: {
      type: Array,
      default: () => [],
    },
    pageableSize: {
      type: Number,
      default: 50,
    },
    showRefreshWhenNoData: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    showRefresh() {
      return this.pageableList?.length === 0 && this.showRefreshWhenNoData
    },
    curValue: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
  },
  data() {
    return {
      pageableList: [],
      hasMore: true,
      loading: false,
      visible: false, // to Unified with zm-select
    }
  },
  created() {
    this.pageableList = getTwoDimeArray(
      this.optionsList,
      this.pageableSize
    )?.[0]
  },
  methods: {
    remoteMethods(query, page) {
      this.loading = true
      if (!this.optionsList?.length) return

      if (page === 1) this.pageableList = []

      // to be props
      const list = this.optionsList.filter((item) => {
        return item.name.includes(query)
      })
      if (!list.length) {
        this.loading = this.hasMore = false
        this.pageableList = []
        return
      }
      this.allDataByTwo = getTwoDimeArray(list, this.pageableSize)
      this.pageableList.push(...this.allDataByTwo[page - 1])
      this.loading = false
      this.hasMore = page !== Math.ceil(list.length / this.pageableSize)
    },
    focus() {
      this.$refs.paginationSelect?.focus()
      this.$refs.paginationSelect.visible = true
    },
  },
}
</script>
